import React from "react";
import MainContent from "../../../../widgets/templates/main_content";
import Table from "./table";
import { paths } from "../../../app_modules";
import AdminHeader from "../../../../widgets/templates/admin_header";

function CompetencyPage(){

    return(
        <MainContent>
            <AdminHeader 
                title="Competencias" 
                masivPath={paths.competency_form} 
                createPath={paths.competency_form} 
            />
            <hr />
            <div style={{ width: '100%' }}>
                <Table />
            </div>
        </MainContent>
    );
}

export default CompetencyPage;